"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsSheetTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
function SubscriptionsSheetTitle({ isShowTable, isActiveTrial, isLandscape, isMobile, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const title = isShowTable
        ? isActiveTrial
            ? t(i18n_1.Strings.userOnboarding.subsSheet.existingUserTitle)
            : t(i18n_1.Strings.userOnboarding.subsSheet.title)
        : t(i18n_1.Strings.userOnboarding.subsSheet.buy.title);
    const subtitle = isShowTable
        ? t(i18n_1.Strings.userOnboarding.subsSheet.subtitle)
        : t(i18n_1.Strings.userOnboarding.subsSheet.buy.subtitle);
    const showTitle = !isMobile || (isMobile && (!isLandscape || isShowTable));
    return ((0, jsx_runtime_1.jsxs)(HeadingContainer, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetTitle_HeadingContainer', children: [showTitle && (0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'SubscriptionsSheetTitle_StyledTitle', children: title }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { isMobile: isMobile, "data-e2e": 'SubscriptionsSheetTitle_StyledSubtitle', children: subtitle })] }));
}
exports.SubscriptionsSheetTitle = SubscriptionsSheetTitle;
const HeadingContainer = styled_components_1.default.div `
  margin-bottom: 0.25em;

  ${({ isMobile, isLandscape }) => isMobile && !isLandscape && `margin: 0 12%;`}
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  font-size: 32px;
  margin-bottom: 0.15em;
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  font-size: 16px;

  ${({ isMobile }) => isMobile && `font-size: 20px;`}
`;
